module.exports = __webpack_public_path__ + "static/media/if_-_Magnifier-Search-Zoom-_3844467.2e59eb71.svg";